import React from 'react';

import * as styles from './checklist.module.css';
import { SystemIcon } from '../system-icon';
import classNames from 'classnames';

export function Checklist({
  checklist,
  textClass,
  icon
}) {
  return (
    <ul className={styles.container}>
      {checklist?.map((item, index) => {
        const color = icon?.iconColor;
        const svg = icon?.icon;
        const size = icon?.iconSize;

        return (
          <li
            className={styles.item}
            key={`${item}-${index}`}
          >
            <div
              style={{
                marginTop: (24 - size) / 2
              }}
            >
              <SystemIcon
                icon={svg}
                iconColor={color}
                iconSize={size}
              />
            </div>
            <p
            className={[textClass]}
            >{item}</p>
          </li>
        );
      })}
    </ul>
  );
};
